module.exports = __webpack_public_path__ + "static/media/photo47.4f6a14e8.jpg";